import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "min-h-screen flex flex-col" }
const _hoisted_2 = {
  "aria-label": "admin",
  class: "border-b border-accent"
}
const _hoisted_3 = { class: "max-w-6xl mx-auto px-4 md:px-8 py-3 flex flex-wrap items-center gap-4" }
const _hoisted_4 = { class: "flex flex-wrap gap-4 text-sm list-none p-0 m-0" }
const _hoisted_5 = { class: "flex-grow max-w-6xl w-full mx-auto px-4 md:px-8 py-6" }
const _hoisted_6 = {
  key: 0,
  class: "text-2xl mb-6"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Shell',
  props: {
    title: {}
  },
  setup(__props: any) {



const route = useRoute()

// The server middleware only lets an authenticated admin reach these
// pages, so remember the visit to surface an "Admin" shortcut in the
// main site navigation.
onMounted(() => {
  try {
    localStorage.setItem('admin-visited', '1')
  }
  catch {
    // storage unavailable (private browsing etc.)
  }
})

const nav = [
  { label: 'Dashboard', to: '/admin' },
  { label: 'AMA', to: '/admin/ama' },
  { label: 'Talks', to: '/admin/talks' },
  { label: 'Uses', to: '/admin/uses' },
  { label: 'Entities', to: '/admin/entities' },
  { label: 'Invites', to: '/admin/invites' },
  { label: 'Location', to: '/admin/location' },
]

function isActive (to: string) {
  if (to === '/admin') return route.path === '/admin'
  return route.path === to || route.path.startsWith(`${to}/`)
}

return (_ctx: any,_cache: any) => {
  const _component_NuxtLink = _resolveComponent("NuxtLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_NuxtLink, {
          to: "/admin",
          class: "text-lg font-medium"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" admin ", -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(nav, (item) => {
            return _createElementVNode("li", {
              key: item.to
            }, [
              _createVNode(_component_NuxtLink, {
                to: item.to,
                class: _normalizeClass([isActive(item.to) ? 'text-primary' : 'text-muted hover:text-primary', "transition-colors"])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.label), 1)
                ]),
                _: 2
              }, 1032, ["to", "class"])
            ])
          }), 64))
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("form", {
          method: "POST",
          action: "/api/admin/auth/logout",
          class: "ml-auto"
        }, [
          _createElementVNode("button", {
            type: "submit",
            class: "text-sm text-muted hover:text-primary transition-colors"
          }, " Sign out ")
        ], -1))
      ])
    ]),
    _createElementVNode("main", _hoisted_5, [
      (__props.title)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_6, _toDisplayString(__props.title), 1))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})